// import './Home.css'
import { BottomNavbar,Footer,Hero, Navbar, ProductsArea, CategoriesSlider, InstagramPopup } from '../components'

const Home = ({endPoint, contentLng, choice}) => {

    return (
        <div className='Home'>
            <Navbar endPoint={endPoint} />
            <Hero endPoint={endPoint} heroBg={'/cover-risto.jpeg'} mt='0px' textInHero={`Your Next Addiction`}/>
            <CategoriesSlider contentLng={contentLng} endPoint={endPoint} />
            <ProductsArea contentLng={contentLng} endPoint={endPoint} choice={choice} />
            <Footer contentLng={contentLng} />
            <BottomNavbar />
            <InstagramPopup contentLng={contentLng} />
        </div>

    )
}

export default Home